// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__23uu2","approved":"Status_approved__2x0ja","rejected":"Status_rejected__1NN-W","expired":"Status_expired__2Tj4f","label":"Status_label__2nmMZ"};